export { default as IconCategoryBottom } from './bottom.svg';
export { default as IconCategoryFace } from './face.svg';
export { default as IconCategoryFacialHair } from './facial-hair.svg';
export { default as IconCategoryGlasses } from './glasses.svg';
export { default as IconCategoryHair } from './hair.svg';
export { default as IconCategoryHat } from './hat.svg';
export { default as IconCategoryLeftHand } from './left-hand.svg';
export { default as IconCategoryRightHand } from './right-hand.svg';
export { default as IconCategoryTop } from './top.svg';
